import { registerComponent } from "helpers";

registerComponent(
  "navigation-scroll",
  class NavigationScroll extends HTMLElement {
    constructor() {
      super();

      const scrollId = this.getAttribute("data-scroll-id");
      const ulElement = this.querySelector("ul");

      const createListItem = (listItem) => {
        const id = listItem.getAttribute("id");
        const template = this.querySelector(
          'template[data-template="list-item-template"]',
        );
        const listElement = template.content.cloneNode(true);

        const linkElement = listElement.querySelector("a");
        linkElement.href = `#${id}`;
        linkElement.textContent = listItem.firstChild.nodeValue;

        ulElement.appendChild(listElement);
      };

      const navItems = document.querySelectorAll(`[data-scroll="${scrollId}"]`);

      navItems.forEach(createListItem);
    }
  },
);
